import {
  TeContainer,
  TeText,
  TeIcon,
  TeContainerSlim,
  TeTable,
  TeRow,
  TeCell,
  TeImage,
} from '@topcon/tuicl-react';
import { IconName } from '@topcon/tuicl/dist/components/icon/icon.utils';

import { DeleteItem } from './ConfirmDeletionModal.types';

interface Props {
  text?: string;
  subText?: string | string[];
  headers?: { text: string; subText: string };
  data?: DeleteItem[];
  iconName: IconName;
  iconColor?: string;
  imageSrc?: string;
}

function ModalItems({ text, subText, headers, data, iconName, iconColor, imageSrc }: Props) {
  const renderItem = () => (
    <TeContainer fill borderColor="border.primary" borderRadius={4} gap="s" overflow="hidden">
      {iconName === 'account_circle' ? (
        // TODO: Fix user icon size to be 40x40
        <TeIcon name={iconName} color={iconColor} size="xl" />
      ) : imageSrc ? (
        <TeImage borderRadius={12} imageSource={imageSrc} height={48} width={48} />
      ) : (
        <TeContainerSlim backgroundColor="background.tertiary" padding="xs" borderRadius={20}>
          <TeIcon name={iconName} color={iconColor} size="l" />
        </TeContainerSlim>
      )}
      <TeContainerSlim gap="xs2" column overflow="hidden" fill justifyContent="center">
        <TeText weight={700} truncate>
          {text || (data && data[0]?.text)}
        </TeText>
        {Array.isArray(subText) ? (
          <TeContainerSlim column overflow="hidden" fill>
            {subText.map((text) => (
              <TeText key={text} size={12} color="text.secondary" truncate>
                {text}
              </TeText>
            ))}
          </TeContainerSlim>
        ) : (
          <TeText size={12} color="text.secondary">
            {subText || (data && data[0]?.subText)}
          </TeText>
        )}
      </TeContainerSlim>
    </TeContainer>
  );

  const renderTable = () => (
    <TeTable size="s" evenOdd>
      <TeRow>
        <TeCell>
          <TeText weight={700} size={14}>
            {headers?.text}
          </TeText>
        </TeCell>
        <TeCell>
          <TeText weight={700} size={14}>
            {headers?.subText}
          </TeText>
        </TeCell>
      </TeRow>
      {data &&
        data.map(({ id, text, subText }) => {
          return (
            <TeRow key={id}>
              <TeCell>
                <TeText size={12}>{text}</TeText>
              </TeCell>
              <TeCell>
                <TeText size={12}>{subText}</TeText>
              </TeCell>
            </TeRow>
          );
        })}
    </TeTable>
  );

  if (data && data.length > 1) return renderTable();
  return renderItem();
}

export default ModalItems;
